import { riskTypes } from "../data";
import SectionHeader from "./SectionHeader";

export default function RiskTypes() {
  return (
    <section id="riskTypes" className="scroll-mt-20 bg-background-50">
      <div className="site-container py-12 md:py-16">
        <SectionHeader
          eyebrow="塌房风险盘点"
          eyebrowIcon="ri-align-left"
          title="六大常见塌房类型，你遇到的是哪一种？"
          desc="不同类型的塌房，其形成逻辑、爆发速度与杀伤力各不相同。先认清类型，才能在信号出现时快速判断风险等级。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {riskTypes.map((r) => (
            <article
              key={r.title}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-100/70 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex items-center justify-center w-11 h-11 rounded-lg bg-primary-500 text-background-50">
                  <i className={`${r.icon} text-xl w-6 h-6 flex items-center justify-center`} aria-hidden="true"></i>
                </span>
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900 whitespace-nowrap">
                  <i className="ri-flashlight-line text-xs w-3 h-3 flex items-center justify-center" aria-hidden="true"></i>
                  {r.level}
                </span>
              </div>
              <h3 className="mt-4 text-base md:text-lg font-bold text-foreground-950">{r.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{r.desc}</p>
            </article>
          ))}
        </div>

        <p className="mt-8 flex items-start gap-2 rounded-lg border border-accent-200 bg-accent-50 p-4 text-sm leading-relaxed text-accent-900">
          <i className="ri-lightbulb-flash-line text-lg w-5 h-5 flex items-center justify-center mt-0.5" aria-hidden="true"></i>
          <span>
            <strong className="font-semibold">小提示：</strong>
            六大类型并非孤立存在。现实中，一场危机往往由「言论翻车」点燃，再牵连出「私德争议」与「商务失信」。
            当我们看到某一种信号冒头时，不妨顺着线索检查一下其余维度，避免只盯着单一问题。
          </span>
        </p>
      </div>
    </section>
  );
}